module.exports = __webpack_public_path__ + "static/media/ProximaNova-Reg.c2822d0a.woff";